import { trackCustomEvent } from './helper.es.js';
import { AddToCartType } from './interface.es.js';
import { trackMetaPixelAddToCart } from './meta-pixel.es.js';

const trackAddToCart = (trackAddToCartParams, isIdleCallback = false) => {
  const {
    product,
    selectedPromotionId,
    status,
    cartId,
    type = AddToCartType.ADDTOCART
  } = trackAddToCartParams;
  const { defaultPromotions = [] } = product;
  const trackingData = {
    cartId,
    skuId: product.sku,
    skuName: product.name,
    promotionId: `${[
      ...defaultPromotions.map((promo) => promo.id),
      selectedPromotionId || ""
    ].join(",")}`,
    status: status || "success",
    quantity: 1,
    price: product.price,
    promotionPrice: product.addToCartPrice
  };
  const track = () => {
    var _a, _b;
    if (type === AddToCartType.ADDTOCART) {
      window.track(AddToCartType.ADDTOCART, trackingData);
    } else {
      trackCustomEvent(AddToCartType.BUYNOW, {
        action: "click",
        category: "cart",
        label: JSON.stringify(trackingData),
        property: "product"
      });
    }
    (_a = window.dataLayer) == null ? void 0 : _a.push({
      event: type,
      ecommerce: {
        currencyCode: "VND",
        add: {
          products: [
            {
              name: product.name,
              id: product.sku,
              price: product.addToCartPrice,
              quantity: 1,
              category: product.categories,
              brand: product.brand,
              sellerSku: product.sellerSku
            }
          ]
        }
      }
    });
    if (!!window.fbq && status === "success" && !!((_b = window.env) == null ? void 0 : _b.FB_PIXEL_ID)) {
      trackMetaPixelAddToCart({
        content_ids: [product.sku],
        content_name: product.name,
        content_type: "product",
        contents: [{ id: product.sku, quantity: 1 }],
        currency: "VND",
        value: product.price
      });
    }
  };
  if (isIdleCallback) {
    requestIdleCallback(() => {
      track();
    });
  } else {
    track();
  }
};
const trackIncreaseQuantityProduct = (item, diff = 1, cartId) => {
  var _a, _b, _c, _d, _e;
  window.track("increaseQuantityProduct", {
    cartId,
    skuId: item.displaySku,
    skuName: item.name,
    status: "success",
    quantity: item.quantity + diff,
    price: item.sellPrice,
    promotionPrice: item.price,
    comboPromotion: (_d = (_c = (_b = (_a = item.promotions) == null ? void 0 : _a[0]) == null ? void 0 : _b.promotions) == null ? void 0 : _c[0]) == null ? void 0 : _d.promotionId
  });
  (_e = window.dataLayer) == null ? void 0 : _e.push({
    event: AddToCartType.ADDTOCART,
    ecommerce: {
      currencyCode: "VND",
      add: {
        products: [
          {
            name: item.name,
            id: item.sku,
            price: item.price,
            quantity: diff,
            category: "",
            sellerSku: item.displaySku
          }
        ]
      }
    }
  });
};
const trackDecreaseQuantityProduct = (item, diff = 1, cartId) => {
  var _a, _b, _c, _d;
  window.track("decreaseQuantityProduct", {
    cartId,
    skuId: item.displaySku,
    skuName: item.name,
    status: "success",
    quantity: item.quantity - diff,
    price: item.sellPrice,
    promotionPrice: item.price,
    comboPromotion: (_d = (_c = (_b = (_a = item.promotions) == null ? void 0 : _a[0]) == null ? void 0 : _b.promotions) == null ? void 0 : _c[0]) == null ? void 0 : _d.promotionId
  });
};
const trackChangeQuantityProduct = (item, newQty, cartId) => {
  const currQty = item.quantity;
  if (currQty < newQty) {
    trackIncreaseQuantityProduct(item, newQty - currQty, cartId);
  } else if (currQty > newQty) {
    trackDecreaseQuantityProduct(item, currQty - newQty, cartId);
  }
};
const trackRemoveFromCart = (item, cartId) => {
  var _a, _b, _c;
  window.track("removeFromCart", {
    cartId,
    skuId: item.displaySku,
    skuName: item.name,
    status: "success",
    quantity: item.quantity,
    price: item.sellPrice,
    promotionPrice: item.price,
    promotionId: `${(_a = item.promotions) == null ? void 0 : _a.map((promo) => promo.promotions.map((promo2) => promo2.promotionId).join(",")).join(",")}`,
    promotionsCode: `${(_b = item.promotions) == null ? void 0 : _b.map((promo) => promo.promotions.map((promo2) => promo2.promotionCode).join(",")).join(",")}`
  });
  (_c = window.dataLayer) == null ? void 0 : _c.push({
    event: "removeFromCart",
    ecommerce: {
      remove: {
        products: [
          {
            name: item.name,
            id: item.sku,
            price: item.price,
            quantity: item.quantity,
            category: "",
            sellerSku: item.displaySku
          }
        ]
      }
    }
  });
};
const trackManually = (contentName, regionName, target, payload, index) => {
  window.track("manualTrackInteractionContent", {
    interaction: "click",
    contentName,
    regionName,
    target,
    payload,
    index
  });
};
const trackAddToCartManually = (trackingScreenName, sku) => {
  return trackManually("addToCart", "productCard", trackingScreenName, JSON.stringify({
    sku,
    screenName: trackingScreenName,
    index: 0
  }));
};
const trackSelectProduct = (item, checked, cartId) => {
  window.track(checked ? "selectProduct" : "unselectProduct", {
    cartId,
    skuId: item.displaySku,
    skuName: item.name,
    price: item.sellPrice,
    promotionPrice: item.price,
    quantity: item.quantity,
    status: "success"
  });
};
const trackPVFormAddToCart = (value, emailSha256, phoneSha256) => {
  var _a;
  const data = {
    event: "pv_formaddtocart",
    currency: "VND",
    value
  };
  if (!!emailSha256) {
    data.sha256_email = emailSha256;
  }
  if (!!phoneSha256) {
    data.sha256_phone_number = phoneSha256;
  }
  (_a = window.dataLayer) == null ? void 0 : _a.push(data);
};

export { trackAddToCart, trackAddToCartManually, trackChangeQuantityProduct, trackDecreaseQuantityProduct, trackIncreaseQuantityProduct, trackManually, trackPVFormAddToCart, trackRemoveFromCart, trackSelectProduct };
